<template>
  <!-- <a-spin size="large" :spinning="loading"> -->
  <div class="home">
    <div>
      <a-select
        class="select"
        style="width: 440px; margin-right: 5px"
        size="large"
        :class="[lang]"
        :placeholder="$t('inputLinkAccount')"
        @change="handleChange"
        v-model="linkedin_email"
      >
        <a-select-option :class="[lang]" value="">{{
          $t("inputLinkAccount")
        }}</a-select-option>
        <a-select-option
          :class="[lang]"
          v-for="(item, index) in linkList"
          :key="index"
          :value="item.linkedin_id"
        >
          {{ item.linkedin_email }}
        </a-select-option>
        <!-- <a-select-option value="new">+ A New LinkedIn Account</a-select-option> -->
      </a-select>
      <a-button
        type="primary"
        :class="[lang]"
        @click="createCampaign"
        size="large"
        id="salse-create-btn"
      >
        {{ $t("Create") }}
      </a-button>
    </div>
    <div class="wrap-table" style="min-height: 650px">
      <ul class="nav">
        <li
          class="left"
          @click="tabHandler('left')"
          :class="{ active: leftActive }"
        >
          <span :class="[lang]">{{ $t("Active") }}</span>
        </li>
        <li
          class="right"
          @click="tabHandler('right')"
          :class="{ active: rightActive }"
        >
          <span :class="[lang]">
            {{ $t("Paused") }}
          </span>
        </li>
      </ul>
      <a-table
        :scroll="{
          x: 1120,
        }"
        :class="{ arTable: lang == 'AR' ? true : false }"
        class="custom-scrollbar capinTable"
        size="middle"
        :columns="columns"
        :rowKey="(record, index) => index"
        :data-source="tableData"
        :pagination="false"
        :loading="loading"
        :locale="{ emptyText: $t('noCamp') }"
        :row-class-name="
          (_record, index) => (index % 2 !== 1 ? 'table-bg' : null)
        "
      >
        <template slot="ProspectiveClients" slot-scope="text, record">
          <span class="skipDetail" @click="goDetail(record, '')">{{
            record.customer_find
          }}</span>
        </template>

        <template slot="connectionsRequest" slot-scope="text, record">
          <span class="skipDetail" @click="goDetail(record, '1')">{{
            record.connections_request
          }}</span>
        </template>

        <template slot="ConnectionsMade" slot-scope="text, record">
          <span class="skipDetail" @click="goDetail(record, '2')">{{
            record.connections_made
          }}</span>
        </template>

        <template slot="NumberOfGreeters" slot-scope="text, record">
          <span class="skipDetail" @click="goDetail(record, '2')">{{
            record.greeting_count
          }}</span>
        </template>

        <template slot="replies" slot-scope="text, record">
          <span class="skipDetail" @click="goDetail(record, '4')">{{
            record.replies
          }}</span>
        </template>
        <template slot="status" slot-scope="text, record" class="arial">
          <div @click.stop="">
            <a-switch
              @click.native.stop=""
              size="small"
              v-model="record.status"
              @change="onChangeRecord(record)"
            />
          </div>
        </template>

        <template slot="campaign_name" slot-scope="text, record">
          {{ record.campaign_name }}
          <CampaignTableTip
            :record="record.action_log"
            v-if="record && record.action_log"
            lable="click_history_records"
            event="campaign"
            method="sales"
          />
        </template>

        <template slot="linkedin_email" slot-scope="text, record">
          <a-tooltip placement="bottom" v-if="record.is_not_friend">
            <template slot="title">
              <span>{{ $t("baibanCampaignTipTxt") }}</span>
            </template>
            <a-icon type="exclamation-circle" class="linkedin_email_warning" />
          </a-tooltip>
          {{ record.linkedin_email }}
        </template>

        <template slot="action" slot-scope="text, record" class="arial">
          <a-dropdown>
            <template #overlay>
              <a-menu>
                <a-menu-item key="0" @click="goEdit(record)">
                  <a-icon type="form" />
                  <span :class="[lang]">{{ $t("campaignEdit") }}</span>
                </a-menu-item>
                <a-menu-item key="1" @click="goDetail(record)">
                  <a-icon type="edit" />
                  <span :class="[lang]">{{ $t("Details") }}</span>
                </a-menu-item>
                <a-menu-item key="2" @click="copyHandler(record)">
                  <a-icon type="copy" />
                  <span :class="[lang]">{{ $t("Copy") }}</span>
                </a-menu-item>
                <a-menu-item key="3" @click="deleteHandler(record)">
                  <a-icon type="delete" />
                  <span :class="[lang]">{{ $t("Delete") }}</span>
                </a-menu-item>
              </a-menu>
            </template>
            <a-button style="padding: 0 8px" @click.stop="">
              <span :class="[lang]">{{ $t("Action") }}</span>
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </template>
      </a-table>
      <div>
        <app-footer
          :current="page"
          :pageSize="pageSize"
          :total="total"
          @onPageChange="onPageChange"
          @onPageSizeChange="onPageSizeChange"
        ></app-footer>
      </div>
    </div>
    <CampaignModalCon
      :showModal.sync="showModal"
      v-if="showModal"
      @saveLinkedIn="saveLinkedIn"
      :newLinkedIn="newLinkedIn"
    />
  </div>
  <!-- </a-spin> -->
</template>

<script>
import BaseComponent from "@/components/base.component";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import CampaignTableTip from "../../hr/recruiter/component/campaignTableTip.vue";
import CampaignModalCon from "@/layouts/globalModals/CampaignModalCon";
import Bus from "@/utils/bus";
import { mapGetters } from "vuex";

export default {
  components: {
    CampaignTableTip,
    CampaignModalCon,
  },
  data() {
    return {
      loading: false,
      leftActive: true,
      rightActive: false,
      tableData: [],
      linkList: [],
      linkedin_email: "",
      driverObj: null,
      setGuideEnd: false,
      newLinkedIn: [],
      showModal: false,
    };
  },
  i18n: require("./i18n"),
  mixins: [BaseComponent],
  computed: {
    ...mapGetters("account", ["user"]),
    columns: {
      get() {
        let that = this;
        return [
          {
            title: that.$t("Name"),
            width: 200,
            dataIndex: "campaign_name",
            // align: "center",
            // ellipsis: true,
            // fixed: "left",
            scopedSlots: {
              customRender: "campaign_name",
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("Status"),
            width: 160,
            dataIndex: "status",
            align: "center",
            // fixed: "left",
            scopedSlots: {
              customRender: "status",
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("LinkedinlD"),
            width: 200,
            dataIndex: "linkedin_email",
            ellipsis: true,
            align: "left",
            scopedSlots: {
              customRender: "linkedin_email",
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("Days"),
            width: 120,
            dataIndex: "days",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("TotalNumber"),
            width: that.lang == "US" ? 260 : that.lang == "AR" ? 200 : 120,
            dataIndex: "customer_find",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "ProspectiveClients",
            },
          },
          {
            title: that.$t("ConnectionsRequest"),
            width: that.lang == "US" ? 200 : that.lang == "AR" ? 200 : 120,
            dataIndex: "connections_request",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "connectionsRequest",
            },
          },
          {
            title: that.$t("ConnectionsMade"),
            width: that.lang == "US" ? 200 : that.lang == "AR" ? 200 : 120,
            dataIndex: "connections_made",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "ConnectionsMade",
            },
          },

          {
            title: that.$t("Acceptedrate"),
            width: 120,
            dataIndex: "accept_rate",
            align: "center",
            customRender: function (text) {
              return text ? text + "%" : "0%";
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("NumberOfGreeters"),
            width: that.lang == "US" ? 200 : that.lang == "AR" ? 200 : 120,
            dataIndex: "greeting_count",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "NumberOfGreeters",
            },
          },

          {
            title: that.$t("Replies"),
            width: 120,
            dataIndex: "replies",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "replies",
            },
          },
          {
            title: that.$t("Repliesrate"),
            width: that.lang == "US" ? 120 : that.lang == "AR" ? 200 : 120,
            dataIndex: "replies_rate",
            align: "center",
            customRender: function (text) {
              return text ? text + "%" : "0%";
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("Message"),
            width: 120,
            dataIndex: "message",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("PotentialLeads"),
            width: that.lang == "US" ? 120 : that.lang == "AR" ? 200 : 120,
            dataIndex: "potential_leads",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("ConversionRate"),
            width: 120,
            dataIndex: "potential_leads_rate",
            align: "center",
            customRender: function (text) {
              return text ? text + "%" : "0%";
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },

          {
            title: that.$t("Action"),
            align: "center",
            fixed: "right",
            width: 120,
            scopedSlots: {
              customRender: "action",
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
        ];
      },
    },
  },
  created() {
    this.initData();
  },
  activated() {
    this.initData();
  },
  methods: {
    initData() {
      this.form.resetFields();
      this.linkedin_email = "";
      this.getLinkList();
      if (this.$route.query.isHave === "1") {
        this.leftActive = false;
        this.rightActive = true;
      } else if (this.$route.query.isHave === "0") {
        this.leftActive = true;
        this.rightActive = false;
      }
      this.getData(this.$route.query.isHave);
      // 浏览器回退后在进入页面按钮不可点击问题
      // let domCreateBtn = document.querySelector('#salse-create-btn')
      // if (domCreateBtn) {
      //   domCreateBtn.classList.remove('driver-no-interaction')
      //   domCreateBtn.classList.remove('driver-active-element')
      // }
      // 校验user数据中值新手引导是否出现过，出现过则不展示
      // if (this.userGuide && this.userGuide.sales_progress == 0) {
      //   this.getDriverInfo()
      // }
      Bus.$on("showCampaignListDriver", () => {
        this.showDriver();
      });
    },
    handleChange() {
      this.page = 1;
      this.getData();
    },

    getLinkList() {
      this.$axios(
        "/linkedin/list",
        { campaign_type: 1, status: 1 },
        "post"
      ).then((res) => {
        if (res.code == 200) {
          this.linkList = res.data;
        }
      });
    },
    deleteHandler(record) {
      let that = this;
      that.writeLog("campaign", "sales", "click_action_delete");
      this.$confirm({
        title: that.$t("confirmDel") + "?",
        // content: h => <div style="color:red;">Some descriptions</div>,
        onOk() {
          that
            .$axios(
              "/sales/campaign_delete",
              { campaign_id: record.id },
              "post"
            )
            .then((res) => {
              if (res.code == 200) {
                if (that.tableData.length == 1 && that.page > 1) {
                  that.page--;
                  that.getData();
                } else {
                  that.getData();
                }
              }
            });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    copyHandler(record) {
      this.writeLog("campaign", "sales", "click_action_copy");
      let { id } = record;
      if (this.user.has_customer_info) {
        this.$router.push({
          path: "/sales/salesReps/createCampaign",
          query: { campaign_id: id, edit: 1 },
        });
      } else {
        this.$router.push({
          path: "/sales/salesReps/collectUserInfo",
          query: { campaign_id: id, edit: 1 },
        });
      }
    },
    goDetail(record, skipStatus) {
      this.writeLog("campaign", "sales", "click_action_detail");
      let { id, status } = record;
      this.$router.push({
        path: "/sales/salesReps/campaignDetail",
        query: {
          campaign_id: id,
          customer_status: status ? 1 : 0,
          status: skipStatus,
        },
      });
    },
    createCampaign() {
      this.writeLog("campaign", "sales", "create");
      this.$router.push({
        path: "/consultation/enter",
        query: {
          campaign_type: 1,
        },
      });
      // if (this.userGuide && this.userGuide.sales_progress == 0) {
      //   this.setGuideEnd = true;
      //   this.driverObj.destroy();
      //   return;
      // }
      // if (this.user.has_customer_info) {
      //   this.$router.push({
      //     path: "/sales/salesReps/createCampaign",
      //     query: { linkedin_id: "new" },
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/sales/salesReps/collectUserInfo",
      //     query: { linkedin_id: "new" },
      //   });
      // }
    },
    getData(isHave) {
      let status = this.leftActive ? 1 : 0;

      if (isHave === "1") {
        status = 0;
      } else if (isHave === "0") {
        status = 1;
      }
      let postData = {
        page: this.page,
        page_size: this.pageSize,
        linkedin_id: this.linkedin_email ? parseInt(this.linkedin_email) : null,
        campaign_status: status,
      };
      if (
        this.linkedin_email !== "new" &&
        this.linkedin_email !== "selectedDaata"
      ) {
        this.linkedin_id = this.linkedin_email;
      }
      this.loading = true;
      this.$axios("/sales/campaign_list", postData, "post")
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            let { list, total_num, page_size } = res.data || {};
            this.detailData = res.data;
            let arr = [];
            list.forEach((item) => {
              item.status = item.status == 0 ? false : true;
              arr.push(item);
            });
            this.tableData = list;
            this.total = total_num;
            this.pageCount = Math.ceil(total_num / page_size);
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    tabHandler(type) {
      if (type == "left") {
        this.leftActive = true;
        this.rightActive = false;
        this.writeLog("campaign", "sales", "click_activate");
      } else {
        this.writeLog("campaign", "sales", "click_paused");
        this.leftActive = false;
        this.rightActive = true;
      }
      this.page = 1;
      this.getData();
    },
    onChangeRecord(record) {
      this.writeLog("campaign", "sales", "click_campaign_status");
      let { id, status } = record;
      if (record.is_not_friend) {
        this.showModal = true;
        this.newLinkedIn = [record.linkedin_email];
        record.status = !record.status;
        return;
      }
      this.$axios(
        "/sales/campaign_change_status",
        { campaign_id: id, change_status: status ? 1 : 0 },
        "post"
      ).then((res) => {
        let { code, data } = res;
        let that = this;
        if (code == 200) {
          if (data.result == 1 && this.tableData.length == 1 && this.page > 1) {
            this.page--;
            this.getData();
          } else if (data.result == 1) {
            this.getData();
          } else if (data.result == 2) {
            //this.getData()
            record.status = !status;
            this.$warning({
              content: this.$t("statusChangeTip"),
              okText: this.$t("goSet"),
              onOk() {
                that.leftActive = true;
                that.rightActive = false;
                that.page = 1;
                that.getData();
              },
            });
          }

          //this.dashBorderData = res.data;
        } else {
          record.status = !status;
        }
      });
      console.log(record, arguments);
    },
    handleMenuClick(val) {
      console.log(val, arguments);
    },
    getCustomCell(record) {
      if (
        record.action_log &&
        record.action_log.action_log &&
        record.action_log.action_log.length > 0
      ) {
        return {
          style: {
            "padding-bottom": "66px",
          },
        };
      }
    },
    goEdit(record) {
      this.writeLog("campaign", "sales", "click_action_edit");
      let { id } = record;
      this.$router.push({
        path: "/sales/salesReps/createCampaign",
        query: {
          campaign_id: id,
          edit: 2,
        },
      });
    },
    getDriverInfo() {
      let destroyAllBtn = false;
      const driverObj = driver({
        steps: [
          {
            element: "#salse-create-btn",
            popover: {
              title: `
                <div class="createCampaignBtnBox">
                  <div class="createCampaignBtn">${this.$t(
                    "CreateFirstSalesCampaign"
                  )}</div>
                  <div class="createCampaignBtn createCampaignBtnActive">${this.$t(
                    "CreateFirstRecruiterCampaign"
                  )}</div>
                </div>
                <div class="SkipAllTutorialsBtn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <g id="退出" transform="translate(-38.4 -38.4)">
                      <path id="路径_113" data-name="路径 113" d="M47.507,38.4a4.022,4.022,0,0,1,4.082,3.96.733.733,0,0,1-1.46.085l-.005-.085a2.556,2.556,0,0,0-2.473-2.5l-.144,0H42.482a2.571,2.571,0,0,0-2.613,2.368l0,.137V50.44a2.556,2.556,0,0,0,2.473,2.5l.144,0h5.025a2.571,2.571,0,0,0,2.613-2.368l0-.137a.733.733,0,0,1,1.466,0A4.017,4.017,0,0,1,47.667,54.4l-.16,0H42.482A4.028,4.028,0,0,1,38.4,50.6l0-.156V42.36A4.017,4.017,0,0,1,42.322,38.4l.16,0h5.025Z" fill="#0e756a"/>
                      <path id="路径_114" data-name="路径 114" d="M416.586,371.2a.358.358,0,0,1,.239.1l2.129,1.9a.538.538,0,0,1,.08.666.445.445,0,0,1-.08.1l-2.129,1.9a.359.359,0,0,1-.559-.1.538.538,0,0,1-.08-.285V374.37h-5.854a.8.8,0,0,1,0-1.586h5.854v-1.109A.442.442,0,0,1,416.586,371.2Z" transform="translate(-364.714 -327.178)" fill="#0e756a"/>
                    </g>
                  </svg>
                  <span>${this.$t("SkipAllTutorials")}</span>
                </div>
              `,
              description: `
                <div class="progressNum">
                  1/5
                </div>
                <div class="des-con">${this.$t("ClickCreateToStart")}</div>
              `,
              side: "right",
              align: "start",
            },
          },
        ],
        animate: false,
        stagePadding: 0, // 框与元素的距离
        stageRadius: 4, // 框的圆角
        popoverOffset: 18, // 弹框与高亮框之间距离
        // disableActiveInteraction: true, // 框住的内容不可点击
        showButtons: [""], // 不展示按钮
        showProgress: false, // 不显示进度
        popoverClass: "driver-guide-popover-campaign-list-class",
        // 取消选择element时调用
        onDeselected: (element, step, options) => {
          console.log("OnDeselected-----", element, step, options);
          if (destroyAllBtn) {
            return;
          }
          // 关闭后回调
          if (step.element == "#salse-create-btn") {
            this.changeDriveGuideIndex(1);
          }
        },
        onDestroyed: () => {
          console.log("------onDestroyed------");
        },
        onHighlighted: () => {
          console.log("---onHighlighted----");
          document
            .querySelector(".createCampaignBtnActive")
            .addEventListener("click", () => {
              this.$router.push({
                path: "/hr/recruiter/campaign",
              });
              driverObj.destroy();
            });
          document
            .querySelector(".SkipAllTutorialsBtn")
            .addEventListener("click", () => {
              destroyAllBtn = true;
              driverObj.destroy();
              this.changeDriveGuideIndex(4);
            });
        },
      });
      this.driverObj = driverObj;
      setTimeout(() => {
        driverObj.drive();
      });
    },
    // 修改值
    async changeDriveGuideIndex(index) {
      this.writeLog("create_campaign", "sales", "click_guide_skip");
      await this.$axios(
        "/public/set_guide",
        {
          type: "sales",
          progress: index,
        },
        "post"
      )
        .then((res) => {
          if (res.code == 200) {
            this.setUserGuide({
              ...this.userGuide,
              sales_progress: index,
            });
            if (this.setGuideEnd) {
              this.$router.push({
                path: "/consultation/enter",
                query: {
                  campaign_type: 1,
                },
              });
              // if (this.user.has_customer_info) {
              //   this.$router.push({
              //     path: "/sales/salesReps/createCampaign",
              //     query: { linkedin_id: "new" },
              //   });
              // } else {
              //   this.$router.push({
              //     path: "/sales/salesReps/collectUserInfo",
              //     query: { linkedin_id: "new" },
              //   });
              // }
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    saveLinkedIn() {
      this.showModal = false;
    },
    showDriver() {
      if (this.userGuide && this.userGuide.sales_progress == 0) {
        setTimeout(() => {
          this.getDriverInfo();
        }, 200);
      }
    },
  },
  deactivated() {
    this.driverObj && this.driverObj.destroy();
    Bus.$off("showCampaignListDriver");
  },
};
</script>

<style lang="less" scoped>
.home {
  // margin-top: 50px;
  padding: 20px 30px;
  ul,
  li {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .wrap-table {
    padding: 0px 20px 12px 20px;
    background: #fff;
    border-radius: 4px;
    margin-top: 20px;
  }
  /deep/.ant-table-row-hover {
    background: rgba(238, 248, 247, 1) !important;
  }
  /deep/.ant-btn {
    background: #0c6158;
    color: #fff;
  }
  .nav {
    padding-top: 20px;
    border-radius: 2px;
    margin-bottom: 15px;
    li {
      // width: 86px;
      height: 28px;
      padding: 0 20px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
      cursor: pointer;
    }
    .left {
      border-radius: 2px 0px 0px 2px;
      border: 1px solid #d6d6d6;
      border-right: none;
    }

    .right {
      border-radius: 0px 2px 2px 0px;
      border: 1px solid #d6d6d6;
      border-left: none;
    }
    .active {
      color: #fff;
      border: 1px solid #0e756a;
      background: #0e756a;
    }
  }
  .capinTable {
    /deep/ tr.ant-table-row {
      position: relative;
    }
  }
}
// /deep/.ant-table-row {
//   cursor: pointer;
// }
.linkedin_email_warning {
  color: #c92222;
  margin-right: 4px;
  font-weight: bold;
}
.skipDetail {
  color: #0e756a;
  cursor: pointer;
}
</style>
